import {onReady} from "../../../../modules/vegas/js/util";
import {VGSpy} from "vgscrollto";

function initVGSpy() {
	let $vg_spy = document.querySelectorAll('[data-vgspy]');
	if ($vg_spy.length) {
		for (let $spy of $vg_spy) {
			new VGSpy($spy);
		}
	}
}

onReady(initVGSpy);

onReady(initVGSpy);
typeof onTurboRender !== 'undefined' && onTurboRender(initVGSpy);
